import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  ProcessModelerState,
  ProcessModelParams,
} from "./processModular-interface";
import { fetchProcessModelJson } from "./processModular-async-calls";

const initialState: ProcessModelerState = {
  processModelers: [],
  isConnect: false,
  nodes: [],
  edges: [],
  // pvs: [],
  selecetedProcessModel: undefined,
  isprocessModelerFetching: false,
  selectedProcessModelJson: "",
  isJsonFetching: false,
  // processVaraibles: [],
  isAnalystView: false,
  selectedNode: undefined,
  processVariables: [],
  selectedTheme: "dark",
};

const processModularSlice = createSlice({
  name: "processModular",
  initialState,
  reducers: {
    setProcessModelers: (
      state,
      action: PayloadAction<ProcessModelParams[]>
    ) => {
      state.processModelers = action.payload;
    },
    setSelectedProcessModel: (
      state,
      action: PayloadAction<ProcessModelParams | undefined>
    ) => {
      state.selecetedProcessModel = action.payload;
    },
    setIsProcessModelerFetching: (state, action: PayloadAction<boolean>) => {
      state.isprocessModelerFetching = action.payload;
    },
    setIsConnect: (state, action: PayloadAction<boolean>) => {
      state.isConnect = action.payload;
    },
    setNodesDetails: (state, action: PayloadAction<any>) => {
      state.nodes = action.payload;
    },
    setEdgesDetails: (state, action: PayloadAction<any>) => {
      state.edges = action.payload;
    },
    setProcessVariables: (state, action: PayloadAction<any>) => {
      state.processVariables = action.payload;
    },
    setIsAnalystView: (state, action: PayloadAction<boolean>) => {
      state.isConnect = action.payload ? false : true;
      state.isAnalystView = action.payload;
    },
    setSelectedNode: (state, action: PayloadAction<any>) => {
      state.selectedNode = action.payload;
    },
    setSelectedtheme: (state, action: PayloadAction<any>) => {
      state.selectedTheme = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder

      .addCase(fetchProcessModelJson.pending, (state) => {
        state.selectedProcessModelJson = "";
        state.isJsonFetching = true;
      })
      .addCase(fetchProcessModelJson.fulfilled, (state, action) => {
        state.selectedProcessModelJson = action.payload.json;
        state.isJsonFetching = false;
      })
      .addCase(fetchProcessModelJson.rejected, (state) => {
        state.selectedProcessModelJson = "";
        state.isJsonFetching = false;
      });
    // .addCase(fetchProcessVaraiblesbyProcessId.pending, (state) => {
    //   state.processVaraibles = [];
    //   state.isJsonFetching = true;
    // })
    // .addCase(fetchProcessVaraiblesbyProcessId.fulfilled, (state, action) => {
    //   state.processVaraibles = action.payload;
    //   state.isJsonFetching = false;
    // })
    // .addCase(fetchProcessVaraiblesbyProcessId.rejected, (state) => {
    //   state.processVaraibles = [];
    //   state.isJsonFetching = false;
    // });
  },
});

export const {
  setProcessModelers,
  setSelectedProcessModel,
  setIsProcessModelerFetching,
  setIsConnect,
  setNodesDetails,
  setEdgesDetails,
  setProcessVariables,
  setIsAnalystView,
  setSelectedNode,
  setSelectedtheme,
} = processModularSlice.actions;

export default processModularSlice.reducer;
